import { useContext } from 'react'

import { ThemeContext, ThemeContextValue } from './ThemeProvider'

export default function useTheme(): ThemeContextValue {
  return useContext(ThemeContext)
}
